import { createUseStyles } from 'react-jss'
import { darkGrey } from '../../../styles/const/colors'
import { tabletDown } from '../../../styles/const/breakpoints'
import { fontWeightBold, fontWeightRegular } from '../../../styles/typography'
import { transitionShort } from '../../../styles/const/common'

const settingsMenuWidth = 327

const useStyles = createUseStyles(theme => ({
  sectionName: {
    fontSize: 18,
    fontWeight: fontWeightBold,
    marginBottom: 18
  },
  nav: {
    maxWidth: settingsMenuWidth,
    flexBasis: settingsMenuWidth,
    margin: 0,
    marginBottom: 38,
    position: 'sticky',
    overflow: 'hidden'
  },
  navItem: {
    fontSize: 16,
    fontWeight: fontWeightBold,
    color: darkGrey
  },
  navLink: {
    color: 'inherit',
    fontWeight: 'inherit',
    textDecoration: 'none',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '10px 10px 10px 14px',
    borderLeft: '4px solid transparent',
    transition: transitionShort,

    '&.selected': {
      borderLeft: `4px solid ${theme.brandPrimary}`
    },
    '&:hover': {
      color: theme.brandPrimary
    }
  },
  navIcon: {
    marginLeft: 10,
    display: 'flex'
  },
  [`@media screen and (${tabletDown})`]: {
    nav: {
      maxWidth: '100%',
      flexBasis: '100%',
      fontSize: 18
    },
    navItem: {
      fontWeight: fontWeightRegular
    },
    navItemName: {
      fontWeight: fontWeightRegular
    }
  }
}))

export default useStyles
